// extracted by mini-css-extract-plugin
module.exports = {"\t":"Register__9__r9Ysq","register":"Register_register__f7jjt","verify":"Register_verify__zA0ZK","codeInput":"Register_codeInput__zLe_c","codeBtn":"Register_codeBtn__4eKDb"};